import AboutImg1 from "../assets/images/AboutImg1.png"
import AboutImg2 from "../assets/images/AboutImg2.png"
import AboutImg3 from "../assets/images/AboutImg3.png"
import AboutImg4 from "../assets/images/AboutImg4.png"
import AboutImg5 from "../assets/images/AboutImg5.png"
import AboutImg6 from "../assets/images/AboutImg6.png"
import Profile1 from "../assets/images/Profile1.svg"
import Profile2 from "../assets/images/Profile2.svg"
import Profile3 from "../assets/images/Profile3.svg"



import Disk from "../assets/icons/Disk"
import Time from "../assets/icons/Time"
import Car from "../assets/icons/Car"
import CarFull from "../assets/icons/CarFull"
import SmartPhone from "../assets/icons/SmartPhone"



export const AboutCards = [
    {
        "id": 1,
        "img": AboutImg1,
        "icon": <CarFull />,
        "status":"left",
        "title": "SFELDINC is a unique high-technology ELD trucking device designed by SFELDINC.",
        "text": " It has improved GPS performance, instant Internet connection, and data recovery. SFELDINC cloud storage allows you to get access to data at any moment. SFELDINC updates automatically and includes an easy-to-use app. Join us now, and start exploring all its benefits!"
    },
    {
        "id": 2,
        "img": AboutImg2,
        "icon": <Disk />,
        "status":"left",
        "title": "Our ELD device is designed especially for fleet and truck drivers who enjoy working hard.",
        "text":"Such drivers respect ELD trucking and honest compliance because they value their hours of service (HOS). That is why ELD mandate compliance with the usage of an electronic logbook (elog) on their vehicles is so important to them."

    },
    {
        "id": 3,
        "img": AboutImg3,
        "status":"left",
        "icon": <Time />,
        "title": "If you cooperate with SFELDINC, we guarantee that using our electronic logging device will be a positive and easy experience.",
        "text": " Our team is available to serve you 24/7. Truck drivers and vehicles with ELD devices certified by FMCSA can save money for fleet owners, and hours of service (HOS) rule violations are reduced."
    },
    {
        "id": 4,
        "img": AboutImg4,
        "status":"left",
        "icon": <SmartPhone />,
        "title": "Choose the best ELD device on the market.",
        "text":" Created with a truck driver in mind, SFELDINC is your reliable partner on the road! It's an FMCSA-certified device that is easy to install. Just place SFELDINC in your vehicle, and it will connect to the control unit via PT30 device."

    },
    {
        "id": 5,
        "img": AboutImg5,
        "status":"left",
        "icon": <Car />,
        "title": "Our ELD for trucks allows the vehicle",
        "text": "owner to facilitate hours of service (HOS) compliance for his fleet management and this ELD device is perfect for big fleets."
    },
    {
        "id": 6,
        "img": AboutImg6,
        "status":"left",
        "icon": <Time />,
        "title": "Have any difficulties?",
        "text":"Our support department is ready to help 24/7 with the ELD system for trucks surrounding questions and other issues. Choose the best ELD service on the market!"

    },
]

export const Clients = [
    {
        "id": 1,
        "img": Profile1,
        "name": "Anthony Long",
        "job": "Driver of Taxir INC",
        "text": `These guys are awsome! The support team is great! Anytime i have questions or comcerns they are on it. These days integrity is hard to come by along with transparency. But these folks have it!
        I’m an owner operator so i deal with alot of different companys & brokers etc. that just tell you what you want hear. The My20 team is just plain & simple great , along with the device that is easy to install & down load app. I was compliant in minutes. Instant gratifacation!! These guys have some great things coming soon to help independent operators & bigger trucking co.
        Get the most out of our business dollar! Bottom line is you can’t go wrong! Reasonable cost, easy install & awsome support! No regrets!      SFELDINC`
    },
    {
        "id": 2,
        "img": Profile2,
        "name": "Morris Friag",
        "job": "Driver of Taxir INC ",
        "text": `This device is awesome. After having an awful experience with the EZ-ELD (both customer service and device were a pain), I decided to order this SFELDINC and give it a try. The only thing that came in the box was this ELD and it’s really small, almost unnoticeable in my truck. The app I downloaded is very user-friendly. It has instructions on how to install the device. The customer service was top notch and they easily put my trucking info in to get the device going. They even checked up on me throughout the day to make sure the device wasn’t glitching on me. So far I haven’t had any problems. It logs my hours as it should and I’m easily able to edit and sign them off. If you are looking for an ELD, this is the one. 100% recommend!`
    },
    {
        "id": 3,
        "img": Profile3,
        "name": "Chad Barbary Rachun",
        "job": "Driver of Info-Impex INC",
        "text": `The hardware is awesome. Owner operators and small fleets need to get their ELD from these guys. I am very happy with the service I am getting. There have been issues along the way but many of them are because all of us are learning how to use the equipment. The driver, truck,hardware, and phone or tablet all have to work together. I have never seen a team respond so quickly and try so hard to make things better. This is old school customer service at its best with real down to earth folks that go above and beyond to help out us truckers. If you need an ELD and have a some patience then buy it from these guys!`
    },
]